// Copyright (c) 2019 Deere & Company
import './index.scss';

import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import LabeledInput from '../../../shared/components/labeled-input';
import MultiSelect from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFunctionCodeList } from '../../repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';

export class FCMAside extends Component {

  state = {
      functionCodes: [],
  };

  handleNameChange = event => {

      this.props.onTextChange( event.target.value );

  };

  handleAsideTextChange = event => {

      this.props.handleAsideTextChange( event );

  };

        handleDropDownChange = obj => {

            const productSeriesIdGrp = [];

            obj.forEach( element => {

                productSeriesIdGrp.push( element.value );

            } );

            this.props.handleAsideProductSeriesChange( productSeriesIdGrp );

            this.props.increaseCounter();
            getFunctionCodeList( this.props.factoryCode, productSeriesIdGrp ).then( response => {


                if ( response ) {

                    const functionCodes = response.map( factoryCode => ( {
                        value: factoryCode.functionCodeId,
                        label: factoryCode.functionCodeName,
                    } ) );
                    this.setState( {
                        functionCodes,
                    } );

                }
                this.props.decreaseCounter();

            } ).catch( ( ) => {

                this.props.decreaseCounter();

            } );

        };

  onFunctionCodeChange = p => {

      // this.props.handleAsideProductSeriesChange(id);
      const event = {
          target: {
              name: 'functionCodeId',
              value: p.value,
          },
      };
      this.props.handleAsideTextChange( event );
      event.target.name = 'functionCodeName';
      event.target.value = p.label;
      this.props.handleAsideTextChange( event );

  }

  render () {

      return (
          <section>
              {!this.props.isEdit && (
                  <div className="select-row-update">
                Select Row To Update

                  </div>
              )}


              {this.props.isEdit && (
                  <div>
                      { !this.props.isAdd && (
                          <LabeledInput
                              className="input-name"
                              isEditable={true}
                              disabled={true}
                              label="Product Series"
                              maxLength={15}
                              value={this.props.partNumber.productSeriesName}
                          />
                      )}
                      { this.props.isAdd && (
                          <div>
                              <label>Product Series</label>
                              <MultiSelect
                                  isPlaceholderTranslated={true}
                                  options={this.props.productSeries}
                                  onChange={this.handleDropDownChange}
                                  value={this.props.value}
                                  isMulti="true"
                                  menuPlacement="auto"
                                  maxMenuHeight={240}
                                  className="claimType-cls"
                                  isRequired={true}
                              />
                          </div>
                      )}
                      { !this.props.isAdd && (
                          <LabeledInput
                              className="input-name"
                              isEditable={true}
                              disabled={true}
                              label="Function Code"
                              maxLength={7}
                              value={this.props.partNumber.functionCodeName}

                          />
                      )}
                      { this.props.isAdd && (
                          <div className="input-name">
                              <label>
                                  <span>Function Code:</span>
                                  <span className="caution">
                                      <span className="is-required red-font"><i className="fa fa-asterisk" /></span>

                                  </span>
                              </label>

                              <CreatableSelect
                                  className="function-code-add"
                                  placeholder=""
                                  closeMenuOnSelect={true}
                                  maxMenuHeight={200}
                                  // menuPortalTarget={document.body}
                                  isDisabled={!this.props.partNumber.productSeriesId}
                                  // styles={optionCodeModalStyleOverrides}
                                  // value={this.props.partNumber.functionCodeName}
                                  options={this.state.functionCodes}
                                  onChange={this.onFunctionCodeChange}

                              />
                          </div>
                      )}
                      <LabeledInput
                          className="input-name"
                          isEditable={true}
                          disabled={!this.props.isAdd}
                          name="partNumber"
                          label="Part Number"
                          maxLength={12}
                          onChange={this.handleAsideTextChange}
                          value={this.props.partNumber.partNumber}
                          isRequired={true}
                      />
                      <LabeledInput
                          className="input-name"
                          isEditable={true}
                          disabled={false}
                          name="manufacturingModule"
                          label="Manufacturing Module"
                          maxLength={5}
                          onChange={this.handleAsideTextChange}
                          value={this.props.partNumber.manufacturingModule}
                      />
                      <LabeledInput
                          className="input-name"
                          isEditable={true}
                          disabled={false}
                          name="designTeamCode"
                          label="Design Module"
                          maxLength={7}
                          onChange={this.handleAsideTextChange}
                          value={this.props.partNumber.designTeamCode}
                      />
                  </div>
              )}
              {this.props.isEdit && !this.props.isAdd && (
                  <div className="button-align search-panel">
                      <button type="button" onClick={this.props.onDelete}>
                          <span> Delete </span>
                      </button>
                      <button
                          type="button"
                          className="primary-button"
                          onClick={this.props.onUpdate}
                      >
                          <span> Update </span>
                      </button>
                  </div>
              )}
              {this.props.isAdd && (
                  <div className="button-align">
                      <button className="close-button" type="button" onClick={this.props.onCancel}>
                          <span> Cancel </span>
                      </button>
                      <button
                          type="button"
                          className="primary-button"
                          onClick={this.props.onUpdate}
                          disabled={!( ( this.props.partNumber.productSeriesId !== undefined && this.props.partNumber.productSeriesId !== '-1' )
                        && ( this.props.partNumber.functionCodeName !== undefined && this.props.partNumber.functionCodeName !== '-1' )
                        && ( this.props.partNumber.partNumber !== undefined && ( this.props.partNumber.partNumber ).trim() !== '' )
                          )}
                      >
                          <span> Add New </span>
                      </button>
                  </div>
              )}
          </section>
      );

  }

}
FCMAside.displayName = 'FCMAside';
FCMAside.propTypes = {
    onTextChange: PropTypes.func.isRequired,
    partNumber: PropTypes.object.isRequired,
    isEdit: PropTypes.bool.isRequired,
    isAdd: PropTypes.bool.isRequired,
    onCancel: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
    productSeries: PropTypes.array.isRequired,
    value: PropTypes.string,
    factoryCode: PropTypes.string.isRequired,
    handleAsideProductSeriesChange: PropTypes.func,
    handleAsideTextChange: PropTypes.func,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
} );
export default connect(
    mapStateToProps, mapDispatchToProps,
)( FCMAside );
// export default FCMAside;
